import { Flex, Image, Tooltip } from '@chakra-ui/react';
import Platforms from '../../../../../utils/platforms';

const PlatformCellRenderer = ({ value }) => {
    const platform = () => {
        const platform = Platforms[value];
        return platform;
    };

    const isEightByEight = platform()?.name === '8x8';
    const rounded8x8Logo = isEightByEight ? 'rounded-full' : '';

    return (
        <Flex align="center" justify="center" height="100%">
            <Tooltip label={platform()?.name} placement="top">
                {/* <> */}
                <Image
                    src={platform()?.icon}
                    boxSize="7"
                    className={rounded8x8Logo}
                />
                {/* {platformName && <span>{platform()?.name}</span>} */}
                {/* </> */}
            </Tooltip>
        </Flex>
    );
};

export default PlatformCellRenderer;
